<!-- UNIVAPLAT-3519: deactivate contract modal (role/aria-modal/focus trap come from NgbModal) -->
<div class="modal-header">
    <h1 class="modal-title fs-5 fw-normal" id="deactivate-contract-title" data-testid="deactivate-title">Confirm the action</h1>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss(false)"
            data-testid="deactivate-close"></button>
</div>
<div class="modal-body">
    <p id="deactivate-contract-description" data-testid="deactivate-description">Are you sure you want to deactivate this contract?</p>
    <p>A deactivated contract becomes read-only until it is reactivated.</p>
    <label for="deactivate-reason" class="form-label">Reason (optional)</label>
    <textarea id="deactivate-reason" class="form-control" rows="3"
              [formControl]="reason"
              [class.is-invalid]="reason.invalid"
              [attr.aria-invalid]="reason.invalid"
              aria-describedby="deactivate-reason-hint deactivate-reason-error"
              data-testid="deactivate-reason"></textarea>
    <div id="deactivate-reason-hint" class="form-text">{{ length }} / {{ maxLength }} characters</div>
    <div id="deactivate-reason-error" aria-live="polite">
        @if (reason.errors?.['maxlength']) {
            <div class="invalid-feedback d-block" data-testid="deactivate-reason-error">
                The reason must be {{ maxLength }} characters or fewer.
            </div>
        }
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-gray text-dark" (click)="modal.dismiss(false)"
            data-testid="deactivate-cancel">No, cancel</button>
    <button type="button" class="btn btn-outline-danger"
            [disabled]="saving || reason.invalid"
            (click)="submit()"
            data-testid="deactivate-submit">
        Yes, proceed
    </button>
</div>
